import { Turbo } from "@hotwired/turbo-rails";
window.Turbo = Turbo;

import Rails from "@rails/ujs"
Rails.start()

// These plugins have no default export, so import them bare. A default import
// throws under Vite's dev ESM interop.
import 'bootstrap462';
import 'bootstrap-select';
import "jquery-ui-bundle";

// Use window.jQuery directly. The "jquery" alias is a CJS shim with no ESM
// default under the dev server.
const jQuery = window.jQuery;
import mousewheelFactory from "jquery-mousewheel";
import mCustomScrollbarFactory from "malihu-custom-scrollbar-plugin";
import "../vendor/loadingoverlay";
mousewheelFactory(jQuery);
mCustomScrollbarFactory(jQuery);

import "../controllers";

import "../../assets/stylesheets/application";

// Legacy jQuery/JavaScript
import "../src/main.js";

import "bootstrap-timepicker";
import "bootstrap462/js/dist/tooltip";

// Registers Chart.js as the Chartkick adapter and fires "chartkick:load". The
// chart helpers emit inline scripts that run before this deferred module, so they
// wait for that event. A bare "chartkick" import skips the adapter.
import "chartkick/chart.js";
import "../src/chartkick_turbo";

import "../src/import_upload_status_guard";

// src/main.js calls ahoy.track() as a bare global. ahoy.js resolves to CJS under
// the bundler and never sets window.ahoy itself.
import ahoy from "ahoy.js";
window.ahoy = ahoy;

import * as L from "leaflet";
import "leaflet-extra-markers";

import Uploader from "../components/Uploader";
import Search from "../components/Search";
window.Uploader = Uploader;
window.Search = Search;

import ReactRailsUJS from "react_ujs";
ReactRailsUJS.detectEvents();

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
